// Enhance the existing chart; without JavaScript its anchor remains usable.
if (!customElements.get('blankloom-size-chart')) {
  customElements.define('blankloom-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
      } else {
        this.initialize();
      }
    }

    initialize() {
      if (!this.isConnected || this.controller) return;
      const content = this.querySelector('[data-size-chart-content]');
      if (!content || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = document.createElement('dialog');
      dialog.className = 'blankloom-size-chart-dialog';
      dialog.id = `${this.id}-dialog`;
      dialog.setAttribute('aria-labelledby', `BlankloomSizeChartTitle-${this.dataset.sectionId}`);
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'blankloom-size-chart-close';
      close.setAttribute('aria-label', 'Close size chart');
      close.textContent = '×';
      const hint = document.createElement('p');
      hint.className = 'blankloom-size-chart-scroll-hint';
      hint.textContent = 'Scroll the table sideways to see all measurements.';
      dialog.append(close, content, hint);
      this.append(dialog);
      this.dialog = dialog;
      this.dataset.enhanced = '';

      // Delegation survives the theme replacing the variant-picker markup.
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-size-chart-target]');
        if (!trigger || trigger.dataset.sizeChartTarget !== this.id) return;
        event.preventDefault();
        this.trigger = trigger;
        if (!dialog.open) {
          dialog.showModal();
          this.previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          close.focus();
        }
      }, options);
      close.addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => this.restorePage(), options);
    }

    restorePage() {
      if (this.previousOverflow !== undefined) {
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.restorePage();
      this.controller?.abort();
      this.controller = null;
      if (this.dialog) {
        this.append(this.dialog.querySelector('[data-size-chart-content]'));
        this.dialog.remove();
        this.dialog = null;
      }
      delete this.dataset.enhanced;
    }
  });
}
